//---------------------Basic imports-----------------------
import React from "react";
import "./Input.scss";

//--------------------Libraries----------------------------
import clsx from "clsx";

const Input = ({
  value,
  onChange,
  error,
  placeholder,
  label,
  name,
  formHelper,
  type = "text",
}) => {
  //---------------------Handlers--------------------

  const changeHandler = (e) =>
    formHelper
      ? onChange(e.target.name, e.target.value)
      : onChange(e.target.value);

  //---------------------Layout-----------------------

  return (
    <div>
      {label && <div className={clsx("input-label")}>{label}</div>}
      <input
        type={type}
        className={clsx("inputArea")}
        name={name}
        value={value}
        onChange={changeHandler}
        placeholder={placeholder}
      />
      <span className="input-error-text">{error}</span>
    </div>
  );
};

export default Input;
